<div
  class="search-active-filters-summary"
  *ngIf="(items?.length ?? 0) > 0"
  data-testid="active-filters-summary"
>
  <div class="search-active-filters-summary-header">Active filters</div>

  <div class="search-active-filters-summary-chips">
    <span
      class="search-active-filters-summary-chip"
      *ngFor="let item of items"
      data-testid="active-filter-chip"
    >
      <span class="search-active-filters-summary-chip-label">
        {{ item.label }}
      </span>

      <button
        type="button"
        class="search-active-filters-summary-chip-remove"
        aria-label="Remove active filter"
        data-testid="active-filter-chip-remove"
        (click)="removeItem(item); $event.stopPropagation()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </span>
  </div>

  <div class="search-active-filters-summary-actions">
    <button
      type="button"
      mat-stroked-button
      color="primary"
      (click)="clearAll.emit()"
      data-testid="active-filters-clear-all"
    >
      {{ clearButtonLabel }}
    </button>
  </div>
</div>
